// extracted by mini-css-extract-plugin
export var chevron = "_ho-2";
export var dropdownItems = "_ho-0";
export var item = "_ho-1";